import React, { useState } from 'react';
import styles from './interes-tags.module.css';
import PropTypes from 'prop-types';

const InterestsTags = ({ children }) => {
    const [selected, setSelected] = useState(false);

    const handleSelected = () => {
        selected ? setSelected(false) : setSelected(true);
    };

    return (
        <>
            <a
                className={`${styles.container} ${
                    selected ? styles.selected_background : ''
                }`}
                onClick={handleSelected}
                href="#!">
                <span
                    className={`${styles.name__button} ${
                        selected ? styles.color_selected_text : ''
                    }`}>
                    {children}
                </span>
            </a>
        </>
    );
};

InterestsTags.propTypes = {
    children: PropTypes.node.isRequired
};
export default InterestsTags;
